import { updateAvatar as updateAvatarEndpoint } from '../endpoints';

export function updateAvatar(file: File) {
  return updateAvatarEndpoint.requestAsPromise({ input: { image: file } });
}
